import React from "react";
import "../Style/AboutDetail.scss";


const AboutDetail = ({ info }) => {
  return (
    
   
    <div  className="about_card col-md-3">
      <div className=" card_inner aboutus_info">
        <div style={{ backgroundColor: info.bg }} className="card_front">
          <img className="about_img" src={info.img} alt="img" />
          <h3 className="aboutus1_h3">{info.title1}</h3>
          <p className="aboutus1_p">{info.des1}</p>
        </div>
        <div className="card_back">
          <div>
          <h4 className="aboutus2_h4">{info.title2}</h4>
          <p className="aboutus2_p">{info.des2}</p>
          </div>
         </div>
      </div>
      {/* <img src={img7} alt=""/> */}
    </div>
  );
};

export default AboutDetail;
